package com.vidaensupalabra.vsp.utils

// Intenta compartir el texto nativamente en la web.
// Retorna true si abrió el menú nativo (Web Share API), o false si solo copió al portapapeles.
fun shareText(text: String): Boolean {
    return try {
        shareViaBrowser(text)
    } catch (e: Exception) {
        e.printStackTrace()
        false
    }
}

// Usamos interoperabilidad nativa de JS/Wasm para acceder a la API del navegador
private fun shareViaBrowser(text: String): Boolean = js("""
    if (window.navigator && window.navigator.share) {
        window.navigator.share({ text: text }).catch(function(e) { console.error("Error sharing:", e); });
        return true;
    } else if (window.navigator && window.navigator.clipboard) {
        window.navigator.clipboard.writeText(text);
        return false;
    }
    return false;
""")